import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { User } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 541. 発注案件担当候補ユーザ一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/target_users
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const purchaseOrderTargetUsers = (props: Props): Promise<User[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/target_users`);
};

export const usePurchaseOrderTargetUsers = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => purchaseOrderTargetUsers(props),
  });
};

export const usePurchaseOrderTargetUsersInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.id, 'target_users'];
};
